import React, { Component } from "react";
import StaticHtmlContent from "../common/staticHtmlContent";
import Spinner from "../common/spinner";

class MessageSpinner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: props.message || ""
        }
    }

    render() {

        return (
            <div className="messageSpinner" style={this.props.style}>
                <div className="maxWidth-content">
                    {this.state.message &&
                        <div className="messageSpinner__msg">
                            <StaticHtmlContent content={this.state.message} />
                        </div>
                    }
                    <div className="doubleSpinner">
                        <div className="outerRing" />
                        <div className="innerRing" />
                        <div className="spinner-bg" />
                    </div>
                </div>
            </div>
       );
    }
}

export default MessageSpinner;